var _rect, _rect2, _g, _rect3, _path, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpdate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 232,
  height: 142,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 232,
  height: 142,
  fill: "#C1CFFA",
  opacity: 0.6,
  rx: 12
})), /*#__PURE__*/React.createElement("mask", {
  id: "update_svg__a",
  width: 232,
  height: 142,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 232,
  height: 142,
  fill: "#E6E6E6",
  rx: 12
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#update_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#454545",
  strokeWidth: 2,
  d: "M83 22h66c6.075 0 11 4.925 11 11v110H72V33c0-6.075 4.925-11 11-11Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3259D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M116 60.5V71l3.5-3.5M116 71l-3.5-3.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3259D8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M103.75 78v-7c0-3.517 0-6.422 5.25-6.93M128.25 78v-7c0-3.517 0-6.422-5.25-6.93"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F56B57",
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M107.25 78c-7 0-7 3.132-7 7v1.75c0 4.83 0 8.75 8.75 8.75h14c7 0 8.75-3.92 8.75-8.75V85c0-3.868 0-7-7-7-1.75 0-2.24.368-3.15 1.05l-1.785 1.89c-2.065 2.205-5.565 2.205-7.647 0l-1.768-1.89c-.91-.682-1.4-1.05-3.15-1.05"
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 3,
  x: 95,
  y: 105,
  fill: "#FDDBD7",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 3,
  x: 95,
  y: 105,
  fill: "#F56B57",
  rx: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 30,
  r: 3,
  fill: "#454545"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F2C94C",
  fillRule: "evenodd",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M78 117c-8.284 0-15-6.716-15-15 0 8.284-6.716 15-15 15 8.284 0 15 6.716 15 15 0-8.284 6.716-15 15-15M188 40c-8.284 0-15-6.716-15-15 0 8.284-6.716 15-15 15 8.284 0 15 6.716 15 15 0-8.284 6.716-15 15-15",
  clipRule: "evenodd"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 22,
  x: 142,
  y: 105,
  fill: "#F8B24F",
  rx: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  d: "M155.508 120.12q-.876 0-1.548-.228a2.96 2.96 0 0 1-1.116-.672 2.9 2.9 0 0 1-.684-1.128q-.228-.672-.228-1.56v-4.308q0-.396.192-.588.204-.192.576-.192t.564.192q.204.192.204.588v4.296q0 1.14.516 1.716.528.564 1.524.564t1.512-.564q.516-.576.516-1.716v-4.296q0-.396.192-.588.204-.192.576-.192.36 0 .552.192.204.192.204.588v4.308q0 1.176-.408 1.98-.396.804-1.188 1.212-.792.396-1.956.396m5.944 2.136q-.36 0-.552-.192t-.192-.564v-6.708q0-.372.192-.564t.54-.192q.36 0 .552.192t.192.564v.936l-.132-.36q.18-.612.732-.984a2.3 2.3 0 0 1 1.308-.372q.768 0 1.344.372.588.372.912 1.056.324.672.324 1.62 0 .936-.324 1.632a2.5 2.5 0 0 1-.9 1.056q-.576.372-1.356.372-.732 0-1.284-.36a1.82 1.82 0 0 1-.744-.96h.144v2.7q0 .372-.204.564-.192.192-.552.192m2.22-3.276q.444 0 .78-.216t.516-.636q.192-.432.192-1.068 0-.96-.408-1.428-.408-.48-1.08-.48a1.4 1.4 0 0 0-.78.216q-.336.204-.528.636-.18.42-.18 1.056 0 .948.408 1.44.408.48 1.08.48m6.487 1.14q-.768 0-1.356-.372a2.5 2.5 0 0 1-.9-1.056q-.324-.696-.324-1.632 0-.948.324-1.62a2.5 2.5 0 0 1 .9-1.056 2.5 2.5 0 0 1 1.356-.372q.732 0 1.272.36.552.36.744.948h-.132v-3.12q0-.372.192-.564t.552-.192.552.192q.204.192.204.564v7.128q0 .372-.192.576-.192.192-.552.192t-.552-.192q-.192-.204-.192-.576v-.936l.132.36q-.18.624-.732.996t-1.296.372m.42-1.14q.444 0 .78-.216t.516-.636q.192-.432.192-1.068 0-.96-.408-1.428-.408-.48-1.08-.48a1.4 1.4 0 0 0-.78.216q-.336.204-.528.636-.18.42-.18 1.056 0 .948.408 1.44.408.48 1.08.48m6.451 1.14a2.6 2.6 0 0 1-1.14-.24 2.07 2.07 0 0 1-.78-.672 1.7 1.7 0 0 1-.276-.948q0-.648.336-1.02.336-.384 1.092-.552t2.028-.168h.6v.864h-.588q-.744 0-1.188.072t-.636.252q-.18.168-.18.48 0 .396.276.648t.768.252q.396 0 .696-.18.312-.192.492-.516t.18-.744v-1.38q0-.6-.264-.864t-.888-.264a3.8 3.8 0 0 0-1.596.372q-.228.108-.408.06a.46.46 0 0 1-.264-.192.63.63 0 0 1-.096-.336q0-.18.096-.348a.57.57 0 0 1 .324-.264q.552-.228 1.056-.324a5 5 0 0 1 .936-.096q.864 0 1.416.264.564.264.84.804.276.528.276 1.368v2.88q0 .372-.18.576-.18.192-.516.192t-.528-.192q-.18-.204-.18-.576v-.576h.096q-.084.42-.336.732-.24.3-.612.468a2.05 2.05 0 0 1-.852.168m7.319 0q-.78 0-1.308-.264a1.7 1.7 0 0 1-.768-.768q-.252-.516-.252-1.272v-2.556h-.624q-.288 0-.444-.144a.57.57 0 0 1-.156-.42q0-.276.156-.42t.444-.144h.624v-1.092q0-.372.192-.564.204-.192.564-.192t.552.192.192.564v1.092h1.272q.288 0 .444.144t.156.42a.57.57 0 0 1-.156.42q-.156.144-.444.144h-1.272v2.472q0 .576.252.864t.816.288q.204 0 .36-.036t.276-.048a.28.28 0 0 1 .24.096q.096.096.096.408 0 .24-.084.432a.44.44 0 0 1-.276.252q-.156.048-.408.084a2.4 2.4 0 0 1-.444.048m4.751 0q-.996 0-1.716-.372t-1.116-1.056q-.384-.684-.384-1.62 0-.912.372-1.596a2.8 2.8 0 0 1 1.044-1.068 2.95 2.95 0 0 1 1.524-.396q.624 0 1.116.204.504.204.852.588.36.384.54.936.192.54.192 1.224a.4.4 0 0 1-.156.336q-.144.108-.42.108h-3.852v-.864h3.372l-.192.18q0-.552-.168-.924a1.17 1.17 0 0 0-.468-.564q-.3-.204-.756-.204-.504 0-.864.24a1.5 1.5 0 0 0-.54.66q-.18.42-.18 1.008v.084q0 .984.456 1.476.468.48 1.368.48.312 0 .696-.072.396-.084.744-.276.252-.144.444-.12a.42.42 0 0 1 .3.132q.12.12.144.3a.56.56 0 0 1-.072.348.74.74 0 0 1-.3.312 3.2 3.2 0 0 1-.972.396q-.54.12-1.008.12"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 22,
  x: 142,
  y: 105,
  stroke: "#454545",
  strokeWidth: 2,
  rx: 11
})));
export default SvgUpdate;